import { Box, Button, useTheme } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

import { getCookie } from '../../../../utils/cookie';
import { getSessionStorage } from '../../../../utils/localStorageUtils';

import { useLoginButtonStyles } from './menuStyles/loginButtonStyles';

interface ISignUpProps {
  size?: string | undefined;
}

const SignUp = (props: ISignUpProps) => {
  const theme = useTheme();
  const styles = useLoginButtonStyles(theme);
  const localStorageValue = getCookie('access_token') ?? getSessionStorage('accessToken') ?? '';
  const spacing = props.size === 'small' ? 1 : 2;

  if (localStorageValue.length !== 0) {
    return null;
  }

  return (
    <Box>
      <Button
        sx={{ marginRight: theme.spacing(spacing) }}
        variant="outlined"
        className={styles.loginButton}
        component={Link}
        to={'/LogIn'}
        size="small"
      >
        Log In
      </Button>
      <Button className={styles.signUpButton} component={Link} size="small" to={'/signup'}>
        Sign Up
      </Button>
    </Box>
  );
};

export default SignUp;
